import React from "react";
import Rollbar from '../utils/RollbarTracking'
import axios from 'axios'
import Select from 'react-select';
import { toast } from 'react-toastify';

export class OrdersCreate extends React.Component {
  constructor(props)  {
    super(props);
    this.handleChangeQty = this.handleChangeQty.bind(this);
    this.handleChangeUnitPrice = this.handleChangeUnitPrice.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleChange2 = this.handleChange2.bind(this);
    this.handleChangeSelect = this.handleChangeSelect.bind(this);
    this.handleChangeSelect2 = this.handleChangeSelect2.bind(this);
  }

  state = {
      orderLineItems: [],
      products: [],
      newTotal: 0,
      subTotal: 0,
      paymentTerms: '',
      customers: [],
      selectedCustomer: {},
      deliveryDays: [],
      selectedDeliveryDay: ''
  }

  componentWillMount() {
    this.fetchCustomers()
  }

  updateTotal() {
    var total = 0
    for (let i = 0; i < this.state.orderLineItems.length; i++) {
      total += this.state.orderLineItems[i].unitPrice*this.state.orderLineItems[i].quantity
    }
    var subTotal = total
    this.setState({newTotal: total.toFixed(2), subTotal: subTotal.toFixed(2)})
  }

  handleChangeQty (evt) {
    var orderLineItems = this.state.orderLineItems
    orderLineItems[evt.target.name].quantity = evt.target.value
    this.setState({ orderLineItems: orderLineItems });
    this.updateTotal()
  }

  handleChangeUnitPrice (evt) {
    var orderLineItems = this.state.orderLineItems
    orderLineItems[evt.target.name].unitPrice = evt.target.value
    this.setState({ orderLineItems: orderLineItems }, () => {
      this.updateTotal()
    });
  }

  handleChange (evt) {
    this.setState({ [evt.target.name]: evt.target.value });
    this.updateTotal(evt.target.value)
  }

  handleChange2 (evt) {
    this.setState({ [evt.target.name]: evt.target.value });
  }

  handleChangeSelect(obj, evt) {
    var orderLineItems = this.state.orderLineItems
    orderLineItems[evt.name].productID = obj.productID
    orderLineItems[evt.name].name = obj.productName
    orderLineItems[evt.name].unitPrice = obj.price
    this.setState({ orderLineItems: orderLineItems });
    this.updateTotal()
  }

  handleChangeSelect2(obj) {
    this.setState({ selectedCustomer: obj });
    this.fetchDeliveryDays(obj.customerID)
    this.fetchProductData(obj.customerID)
  }

  fetchCustomers = async () => {
    axios.get('/customers')
        .then(data => {
          this.setState({
            customers: data.filter(e => e.name && e.company),
          });
        })
        .catch (err => {
          console.error(err);
          Rollbar.error(err)
          toast.error('Failed to get customers')
        })
  }

  fetchDeliveryDays = async (customerID) => {
    axios.get('/customers/' + customerID + '/deliverydays')
        .then(data => {
          if (data.deliveryDays.length > 0) {
            this.setState({
              deliveryDays: data.deliveryDays,
              selectedDeliveryDay: data.deliveryDays[0].str,
              paymentTerms: data.paymentTerms
            });
          } else {
            toast.error('Customer does not have delivery days set')
          }
        })
        .catch (err => {
          console.error(err);
          Rollbar.error(err)
          toast.error('Failed to get delivery days')
        })
  }

  fetchProductData = async (customerID) => {
    axios.get('/products/customer/' + customerID)
        .then(data => {
          this.setState({
            products: data
          });
        })
        .catch (err => {
          console.error(err);
          Rollbar.error(err)
          toast.error('Failed to get products')
        })
  }

  saveChanges = async () => {
    if (Math.sign(this.state.newTotal) === -1) {
      toast.error('Total cannot be negative')
    } else if (this.state.orderLineItems.length === 0) {
      toast.error('Order must contain at least 1 line item')
    } else if (this.state.orderLineItems.some(e => !e.productID)) {
      toast.error('Order contains empty line items')
    } else if (this.state.orderLineItems.some(e => e.unitPrice === '')) {
      toast.error('Order contains line items with empty price')
    } else if (this.state.orderLineItems.some(e => e.quantity === '')) {
      toast.error('Order contains line items with empty quantity')
    } else {
      let requestParams = {
        'customerID': this.state.selectedCustomer.customerID,
        'total': this.state.newTotal,
        'deliveryDay': this.state.selectedDeliveryDay,
        'items': this.state.orderLineItems,
        'paymentTerms': this.state.paymentTerms === null ? this.props.settings.paymentTerms : JSON.parse(this.state.paymentTerms)
      }
      axios.post('/orders', requestParams)
          .then(data => {
            this.props.history.push("/orders/view/" + data.insertId)
          })
          .catch (err => {
            console.error(err)
            Rollbar.error(err)
            toast.error('Failed to save order')
          })
    }
  }

  deleteLineItem(index) {
    var lineItems = this.state.orderLineItems
    lineItems.splice(index,1)
    this.setState({orderLineItems: lineItems})
    this.updateTotal()
  }

  addLineItem() {
    var lineItems = this.state.orderLineItems
    lineItems.push({
      productID: '',
      name: '',
      unitPrice: 0,
      quantity: 1
    })
    this.setState({orderLineItems: lineItems})
  }

    render() {
        return (
          <div>
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-1 mb-3 border-bottom">
              <h1 className="h3">Create Order</h1>
            </div>
            <div className="mar-bot-lg">
              <button type="button" onClick={() => this.saveChanges()} className="btn btn-success btn-sm mar-bot mar-right">Save Changes</button>
              <div className="card">
                <div className="card-header">
                  Order No.
                  <strong>#</strong>
                  <span className="float-right"> <strong>Status: </strong><span className="badge badge-warning">Pending</span></span>
                </div>
                <div className="card-body">
                  <div className="row mb-4">
                    <div className="col-sm-7">
                      <h6 className="mb-3">Customer:</h6>
                      <Select
                        value={this.state.selectedCustomer}
                        onChange={this.handleChangeSelect2}
                        options={this.state.customers}
                        getOptionLabel={(option)=>option.name && option.company ? option.name + ' - ' + option.company : null}
                        getOptionValue={(option)=>option.customerID}
                      />
                    </div>
                    <div className="col-sm-5">
                      <h6 className="mb-3">Delivery Day:</h6>
                      <div className="input-select">
                        <select value={this.state.selectedDeliveryDay} onChange={this.handleChange2} className="form-control" name="selectedDeliveryDay">
                          {this.state.deliveryDays.map((data, i) =>
                            <option key={i}>{data.str}</option>
                          )}
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="table-responsive-sm">
                    <table className="table table-striped">
                      <thead>
                        <tr>
                          <th className="center">#</th>
                          <th>Item</th>
                          <th className="right">Unit Cost</th>
                          <th className="center">Qty</th>
                          <th className="right">Total</th>
                          <th className="right">Action</th>
                        </tr>
                      </thead>
                        <tbody>
                          {this.state.orderLineItems.map((data, i) =>
                            <tr key={i}>
                              <td className="center">{i + 1}</td>
                              <td className="left strong select-editorder">
                              <Select
                                name={i}
                                value={data}
                                onChange={this.handleChangeSelect}
                                options={this.state.products}
                                getOptionLabel={(option)=>option.productName||option.name}
                                getOptionValue={(option)=>option.productID}
                              />
                              </td>
                              <td className="right"><input type="number" min="0" className="medium-input" value={data.unitPrice} onChange={this.handleChangeUnitPrice} name={i} step="0.05" /></td>
                              <td className="center"><input type="number" min="1" className="small-input" value={data.quantity} onChange={this.handleChangeQty} name={i} /></td>
                              <td className="right">{(data.unitPrice*data.quantity).toFixed(2)}</td>
                              <td className="right"><button type="button" onClick={() => this.deleteLineItem(i)} className="btn btn-danger btn-sm">X</button></td>
                            </tr>
                          )}
                          <tr>
                            <td className="orderAdd"><button type="button" onClick={() => this.addLineItem()} className="btn btn-success btn-sm">+</button></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                          </tr>
                        </tbody>
                    </table>
                  </div>
                  <div className="row">
                    <div className="col-lg-4 col-sm-5">
                    </div>
                    <div className="col-lg-4 col-sm-5 ml-auto">
                      <table className="table table-clear">
                        <tbody>
                          <tr>
                            <td className="left">
                              <strong>Subtotal</strong>
                            </td>
                            <td className="right">${this.state.subTotal}</td>
                          </tr>
                          <tr>
                            <td className="left">
                              <strong>Total</strong>
                            </td>
                            <td className="right">
                              <strong>${this.state.newTotal}</strong>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
    }
}
